<template>
  <div>
    <base-nav style="background-color:black !important;" type="default" effect="dark" expand>
      <a class="navbar-brand" href="/">PCHELP</a>
      <a class="btn side3" href="#" @click="addProject(true)">
        <i >разместить заявку</i>
      </a>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <a href="/">
            PCHELP
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <div class="row col-md-10 ">
        <ul class=" navbar-nav  col-md-6     ">




          <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl"  >\

            <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
              <i class="ni ni-ui-04 d-lg-none"></i>
              <span class="nav-link-inner--text">О сайте</span>
            </a>
            <div class="dropdown-menu-inner">
              <router-link
                  to="/"
                  class="media d-flex align-items-center"
                  tag="a">


                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">О сайте</h6>

                </div>

              </router-link>
              <router-link
                  to="/posts"
                  class="media d-flex align-items-center"
                  tag="a">


                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">Записи в блоге</h6>

                </div>

              </router-link>
              <router-link v-if="loaded_blog_category==true" v-for="(category,category_key) in categorys_blog" :value="category_key"
                           :to="{name: 'category_blog', params: { 'alias':category.alias }}"
                           class="media d-flex align-items-center"
                           tag="a">


                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">{{ category.title }}</h6>

                </div>

              </router-link>


            </div>
          </base-dropdown>



          <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl" v-if="is_load_pages && pages.length>0">\

            <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
              <i class="ni ni-ui-04 d-lg-none"></i>
              <span class="nav-link-inner--text">Страницы</span>
            </a>
            <div class="dropdown-menu-inner">
              <router-link v-for="(page,page_key) in pages" :value="page_key"
                           :to="{name: 'page', params: { id: page.last_id }}"
                           class="media d-flex align-items-center"
                           tag="a">

                <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                  <i v-bind:class="page.icon"></i>
                </div>
                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">{{ page.title }}</h6>
                  <p class="description d-none d-md-inline-block mb-0">{{ page.description }}.</p>
                </div>

              </router-link>

            </div>
          </base-dropdown>
          <li class="nav-item" v-if="islogin==true">
            <router-link to="/home" class="nav-link">Проекты</router-link>

          </li>
          <li class="nav-item" v-if="islogin==true">
            <router-link to="/canban" class="nav-link">Канбан</router-link>

          </li>

          <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl" v-if="islogin==true && user.islead && user.islead==1 && funnels.length>0">\

            <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
              <i class="ni ni-ui-04 d-lg-none"></i>
              <span class="nav-link-inner--text">Лиды</span>
            </a>
            <div class="dropdown-menu-inner">
              <router-link v-for="(funnel,funnel_key) in funnels" :value="funnel_key"
                           :to="{name: 'funnel', params: { id: funnel.last_id }}"
                           class="media d-flex align-items-center"
                           tag="a">


                <div class="media-body ml-3">
                  <h6 class="heading text-primary mb-md-1">{{ funnel.title }}</h6>

                </div>

              </router-link>

            </div>
          </base-dropdown>




        </ul>
        <ul class=" navbar-nav  col-md-6  ">

          <li class="nav-item" v-if="islogin==false">
            <base-button class="btn side3"  @click="addProject(false)">
              Войти через Telegram
            </base-button>
          </li>


          <li class="nav-item" v-if="islogin==true">
            <base-notify-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
              <a slot="title" href="#" class="nav-link" @click="loadNotify" data-toggle="dropdown" role="button">
                <i class="ni ni-ui-04 d-lg-none"></i>
                <span class="nav-link-inner--text"><i class="fa fa-bell"></i>  <badge v-if="notify_count>0"
                                                                                      type="danger">{{
                    notify_count
                  }}</badge></span>
              </a>
              <div class="dropdown-menu-inner dropdown-menu-xl2">
                <sui-segment v-if="is_notify_load==false">
                  <sui-dimmer active>
                    <sui-loader size="tiny"></sui-loader>
                  </sui-dimmer>

                </sui-segment>
                <div v-if="is_notify_load">
                  <sui-form-field>
                    <sui-checkbox toggle @change="changeNotifyType" v-model="notify.show_only_unread"
                                  label="Показывать только не прочитанные"/>
                  </sui-form-field>
                  <p><a @click="markerAllNotifyRead">Пометить все прочитанным</a></p>
                  <sui-tab class="notify_bar" :menu="{ vertical: true, fluid:true, tabular: 'left' }">
                    <sui-tab-pane title="Все">
                      <sui-feed>
                        <sui-feed-event
                            v-if="(notify.show_only_unread==true && notify_object.isread==0) || (notify.show_only_unread==false)"
                            v-for="(notify_object,notify_index) in notifys" :key="notify_object.last_id">

                          <sui-feed-content>
                            <sui-feed-summary
                                :date="notify_object.created_at"
                                :user="notify_object.who.name"
                                :content="' '+notify_object.json.title"
                            />
                            <sui-feed-extra>
                              <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                                <a @click="clickNotify(button,notify_object,notify_index)">{{ button.title }}</a>&nbsp;&nbsp;
                                &nbsp;
                              </div>

                            </sui-feed-extra>
                            <sui-feed-meta>
                              <sui-feed-like>

                              </sui-feed-like>
                            </sui-feed-meta>
                          </sui-feed-content>
                        </sui-feed-event>


                      </sui-feed>
                    </sui-tab-pane>

                    <sui-tab-pane icon="folder open" :title="'('+notify_counts.projects+')'">
                      <h3 is="sui-header" dividing>Проекты</h3>
                      <sui-feed>
                        <sui-feed-event v-if="notify_object.json.type=='projects'" v-for="notify_object in notifys"
                                        :key="notify_object.last_id">
                          <sui-feed-label>

                          </sui-feed-label>
                          <sui-feed-content>
                            <sui-feed-summary
                                :date="notify_object.created_at"
                                :user="notify_object.who.name"
                                :content="' '+notify_object.json.title"
                            />
                            <sui-feed-extra>
                              <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                                <a @click="clickNotify(button,notify_object)">{{ button.title }}</a>&nbsp;&nbsp;
                                &nbsp;
                              </div>

                            </sui-feed-extra>
                            <sui-feed-meta>
                              <sui-feed-like>

                              </sui-feed-like>
                            </sui-feed-meta>
                          </sui-feed-content>
                        </sui-feed-event>


                      </sui-feed>

                    </sui-tab-pane>
                    <sui-tab-pane icon="shopping cart" :title="'('+notify_counts.freelance+')'">
                      <h3 is="sui-header" dividing>Фриланс</h3>
                      <sui-feed>
                        <sui-feed-event v-if="notify_object.json.type=='freelance'" v-for="notify_object in notifys"
                                        :key="notify_object.last_id">
                          <sui-feed-label>

                          </sui-feed-label>
                          <sui-feed-content>
                            <sui-feed-summary
                                :date="notify_object.created_at"
                                :user="notify_object.who.name"
                                :content="' '+notify_object.json.title"
                            />
                            <sui-feed-extra>
                              <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                                <a @click="clickNotify(button,notify_object)">{{ button.title }}</a>&nbsp;&nbsp;
                                &nbsp;
                              </div>

                            </sui-feed-extra>
                            <sui-feed-meta>
                              <sui-feed-like>

                              </sui-feed-like>
                            </sui-feed-meta>
                          </sui-feed-content>
                        </sui-feed-event>


                      </sui-feed>

                    </sui-tab-pane>
                    <sui-tab-pane icon="money bill" :title="'('+notify_counts.invoices+')'">
                      <h3 is="sui-header" dividing>Счета</h3>
                      <sui-feed>
                        <sui-feed-event v-if="notify_object.json.type=='invoices'" v-for="notify_object in notifys"
                                        :key="notify_object.last_id">
                          <sui-feed-label>

                          </sui-feed-label>
                          <sui-feed-content>
                            <sui-feed-summary
                                :date="notify_object.created_at"
                                :user="notify_object.who.name"
                                :content="' '+notify_object.json.title"
                            />
                            <sui-feed-extra>
                              <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                                <a @click="clickNotify(button,notify_object)">{{ button.title }}</a>&nbsp;&nbsp;
                                &nbsp;
                              </div>

                            </sui-feed-extra>
                            <sui-feed-meta>
                              <sui-feed-like>

                              </sui-feed-like>
                            </sui-feed-meta>
                          </sui-feed-content>
                        </sui-feed-event>

                      </sui-feed>
                    </sui-tab-pane>
                    <sui-tab-pane icon="comment" :title="'('+notify_counts.comments+')'">
                      <h3 is="sui-header" dividing>Общение</h3>
                      <sui-feed>
                        <sui-feed-event v-if="notify_object.json.type=='comments' || notify_object.json.type=='blogpost_new_comment'" v-for="notify_object in notifys"
                                        :key="notify_object.last_id">
                          <sui-feed-label>

                          </sui-feed-label>
                          <sui-feed-content>
                            <sui-feed-summary
                                :date="notify_object.created_at"
                                :user="notify_object.who.name"
                                :content="' '+notify_object.json.title"
                            />
                            <sui-feed-extra>
                              <div v-for="(button,button_index) in notify_object.json.buttons" :key="button_index">
                                <a @click="clickNotify(button,notify_object)">{{ button.title }}</a>&nbsp;&nbsp;
                                &nbsp;
                              </div>

                            </sui-feed-extra>
                            <sui-feed-meta>
                              <sui-feed-like>

                              </sui-feed-like>
                            </sui-feed-meta>
                          </sui-feed-content>
                        </sui-feed-event>


                      </sui-feed>
                    </sui-tab-pane>
                  </sui-tab>
                </div>
              </div>
            </base-notify-dropdown>
          </li>
          <li class="nav-item" v-if="islogin==true && user.islead && user.islead==1 && funnels.length>0">
            <router-link to="/leadtasks" class="nav-link"><i class="ni ni-watch-time"></i> <badge v-if="notify_count_tasks>0"
                                                                      type="danger">{{
                notify_count_tasks
              }}</badge></router-link>
          </li>
          <li class="nav-item" v-if="islogin==true">
            <router-link to="/invoices" class="nav-link">Счета <badge v-if="notify_count_invoices>0"
                                                                      type="danger">{{
                notify_count_invoices
              }}</badge></router-link>


          </li>
          <li class="nav-item" v-if="islogin==true">


            <base-dropdown tag="li" class="nav-item">
              <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">

                <avatar :size=25 :username="user.name"></avatar>
              </a>
              <router-link to="/setup" class="dropdown-item">Настройки</router-link>

              <router-link v-if="user.isdeveloper==1" to="/portfolio" class="dropdown-item">Портфолио</router-link>
              <router-link v-if="user.isdeveloper==1" :to="{name: 'developer', params: { username: user.username }}"
                           class="dropdown-item">Ваш профиль
              </router-link>

              <button @click="this.Logout" class="dropdown-item"><i class="fa fa-user-secret"></i> Выход</button>
            </base-dropdown>

          </li>


        </ul>
      </div>





    </base-nav>

    <login-modal ></login-modal>
  </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import BaseNotifyDropdown from "@/components/BaseNotifyDropdown";
import CloseButton from "@/components/CloseButton";
import {vueTelegramLogin} from 'vue-telegram-login'
import axios from 'axios';
import {eventBus} from '../main.js';
import Vue from "vue";
import Api from "../models/Api";
import {vm} from "../main.js";
import Modal from "@/components/Modal";
import LoginModal from "../components/LoginModal";
import Avatar from 'vue-avatar'


require('dotenv').config()

export default {

  components: {
    Modal,
    BaseNav,
    CloseButton,
    BaseDropdown,
    BaseNotifyDropdown,
    vueTelegramLogin,
    LoginModal,
    Avatar

  },

  data: function () {

    return {
      'categorys_blog':{},
      loaded_blog_category:false,
      "telegram_bot": null,
      is_disable_editor:false,
      user: {},
      is_load_pages: false,
      pages: [],
      random_code: '',
      funnels:[],
      is_notify_load: false,
      new_task_developer: null,
      "loaded_categorys": false,
      "categorys": null,
      "notifys": null,
      "notify": {
        "show_only_unread": true,
      },
      'modal_params': {},
      "modals": {
        "add_project": null,
      },
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "modal_add_title": "Размещение проекта",
      "is_show_category": true,
      "is_add_task": false,
      "iserror": false,
      "error_message": null,
      "modal_btn_add_project": "Отправить на оценку",
      "form": {
        'category': null,
        'json': {},
        'fields':{},
      },
      "config": {},
      notify_count: 0,
      notify_count_invoices:0,
      notify_count_tasks:0,
      islogin: false,
      'istgbot': false,
      'timer': '',
      'timer_check_code': '',
      show_modal_after_login: true,
    }
  },
  mounted: function () {

    this.random_code = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    var app=this;




    Api.loadPages(function (data) {

      app.pages = data;
      if (app.pages.length > 0) {
        app.is_load_pages = true;
      }

    });
    Api.loadCategorys(function (data) {
      app.categorys = data;
      app.loaded_categorys = true;
    });
    if (this.$store.getters.ISAUTH) {

      var tmpUser = this.$store.getters.USER;
      if(tmpUser.api_token) {
        this.islogin = true;
        this.user = tmpUser;
        app.updateNotifyCount();
        app.timer = setInterval(app.updateNotifyCount, 2000);
        ;
        if (app.islogin == true && app.user.islead == 1) {
          Api.loadFunnels(function (datas) {
            if (datas.funnels.length > 0) {
              app.funnels = datas.funnels;
            }
          })
        }
      }
    } else {

      eventBus.$on('user_is_login', user => {
        this.islogin = false;
        var app=this;
        if (typeof user === 'object') {

          if("api_token" in user){
          if (user.api_token) {
            app.user = user;
            app.islogin = true;
            app.updateNotifyCount();
            app.timer = setInterval(app.updateNotifyCount, 5000);

            if (app.islogin == true && app.user.islead == 1) {
              Api.loadBlogCategorys(function (data) {
                app.categorys_blog = data;
                app.loaded_blog_category = true;
              }, user.api_token);
              Api.loadFunnels(function (datas) {
                if (datas.funnels.length > 0) {
                  app.funnels = datas.funnels;
                }
              })
            }

          }
        }
        }


      });

    }


   // console.log('sample user');
   // console.log(this.$store);
    // let tg_widget = document.createElement('script');
    // tg_widget.setAttribute("src", "https://telegram.org/js/telegram-widget.js?14");
    // tg_widget.setAttribute("data-telegram-login", "Noibizcombot");
    // tg_widget.setAttribute("data-size", "small");
    // tg_widget.setAttribute("data-request-access", "write");
    // //tg_widget.setAttribute("data-onauth", "this.telegramLoginCallback(user)");
    // tg_widget.setAttribute("data-auth-url", "http://1aaa54bb86e2.ngrok.io/#/onlogin");
    // tg_widget.setAttribute("async", "");
    //
    // this.$refs.telegram_login.appendChild(tg_widget);
  },
  methods: {
    testLog() {
      console.log('console log appheader method');
    },
    changeNotifyType() {
      this.loadNotify();
    },
    LoginFromBot() {
      var app = this;
      // console.log('login starting!');
      //console.log();
      app.LoginCheckCode();
      app.timer_check_code = setInterval(app.LoginCheckCode, 2000);
    },
    updateEditorJs(api_token="") {
      this.config = {

        tools: {

          header: require('@editorjs/header'),
          list: {
            class: require('@editorjs/list'),
            inlineToolbar: true,
          },
          "code": require('@editorjs/code'),
          inlineCode: {
            class: require('@editorjs/inline-code'),
            shortcut: 'CMD+SHIFT+M',
          },

          embed: require('@editorjs/embed'),
          linkTool: {
            class: require('@editorjs/link'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/fetchUrl', // Your backend endpoint for url data fetching
            }
          },
          Marker: {
            class: require('@editorjs/marker'),
            shortcut: 'CMD+SHIFT+M',
          },
          table: {
            class: require('@editorjs/table'),
          },

          delimiter: require('@editorjs/delimiter'),
          quote: {
            class: require('@editorjs/quote'),
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+O',
            config: {
              quotePlaceholder: 'Enter a quote',
              captionPlaceholder: 'Quote\'s author',
            },
          },
          attaches: {
            class: require('@editorjs/attaches'),
            config: {
              endpoint: Vue.config.API_URL + 'editor/uploadFile?api_token=' + api_token,
            }
          },
          image: {
            class: require('@editorjs/image'),
            config: {
              additionalRequestHeaders: {
                "Authorization": 'Bearer ' + api_token
              },
              endpoints: {
                byFile: Vue.config.API_URL + 'editor/uploadImage', // Your backend file uploader endpoint

              }

            }
          },
          warning: require('@editorjs/warning'),
          paragraph: {
            class: require('@editorjs/paragraph'),
            inlineToolbar: true,
          },
          checklist: {
            class: require('@editorjs/checklist'),
            inlineToolbar: true,
          },
        },
        "data": {
          "time": 1591362820044,
          "blocks": [
            {
              "type": "header",
              "data": {
                "text": "Название вашего замечательного проекта!",
                "level": 2
              }
            },
            {
              "type": "paragraph",
              "data": {
                "text": "Здесь могут быть описано базовое описание вашего проекта. а также разных требований например:",
              }
            },
            {
              "type": "list",
              "data": {
                "style": "unordered",
                "items": [
                  "Знать Laravel",
                  "Уметь работать с Vue.js",
                  "Уметь работать с REST API"
                ]
              }
            }
          ]
        }
      };
    },
    LoginCheckCode() {

      if (this.islogin) {
        clearInterval(this.timer_check_code);
      }

      var app = this;
      var random_code = app.random_code;
      try{
        Api.LoginCheckCode(random_code, function (data) {
          app.modals.add_project = false;
          console.log('success login code');
          console.log(data);
          localStorage.setItem('api_token', data.user.api_token);
          clearInterval(app.timer_check_code);
          app.$store.commit('SET_TOKEN', data.user.api_token);

          eventBus.$emit('reload', data.user);
          this.modal_add_title = "Размещение проекта";

          if (app.show_modal_after_login == true) {
            app.modals.add_project = true;
          } else {
            app.modals.add_project = false;
          }
        })
      }catch(e){
        console.log('bla bla bla ошибка');
      }


    },
    updateNotifyCount() {
      if (!this.$store.getters.ISAUTH) {
        clearInterval(this.timer);
      }
      var app = this;

      Api.loadNotifyCount(function (notifys) {


        app.notify_count = notifys.count;
        app.notify_count_invoices=notifys.count_invoices;
        app.notify_count_tasks=notifys.count_tasks;


      });
    },
    editWork() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Сохранить изменения";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addPost() {
      this.show_modal_after_login = true
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить пост";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editPost() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Редактировать пост";
      this.form.category = this.modal_params.category;
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editLead(){

      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Отредактировать";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addLead(){
      this.is_disable_editor=true;
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить лида";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addWork() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = true;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить работу";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addTask() {
      this.show_modal_after_login = true;
      this.is_add_task = true;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Добавить задачу";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    editProject() {
      this.show_modal_after_login = true;
      this.is_add_task = false;
      this.is_show_category = false;
      this.form.category = null;
      this.modals.add_project = true;
      if(this.modal_params.project.custom_fields) {
        this.form.fields = this.modal_params.project.custom_fields;
      }

      if(!this.form.fields){
       //var custom_fields={};
        this.form.fields={};
        var parent=this;
        this.modal_params.project.fields.map(function(field) {
          var new_field={};
              parent.form.fields[field.name]="";
          if(field.type=="selectinsert"){
            parent.form.fields[field.name+"_input"]="";
          }



        }


        )


      }





      this.modal_add_title = this.modal_params.modal_title;
      this.modal_btn_add_project = "Сохранить изменения!";
      this.$refs.editor._data.state.editor.render(this.modal_params.json);
    },
    addProject(show_modal_after_login = true) {

      console.log('status login');
      console.log(this.islogin);
      var params={};

      if (this.islogin) {
        params["modal_add_title"]="Размещение проекта";
      } else {
        params["modal_add_title"]="Авторизация в системе";
      }

      params["show_modal_after_login"] = show_modal_after_login;
      params["is_add_task"] = false;
      params['add_project']=true;
      params["modal_params"] = {};
      params["is_show_category"] = true;
      params["form_category"] = null;
      params["modals_add_project"] = true;


      params["modal_btn_add_project"] = "Отправить на оценку";
      eventBus.$emit("call_modal_add_project_from_root", params);


    },
    loadNotify() {
      var app = this;
      app.is_notify_load = false;
      app.notify_counts.comments = 0;
      app.notify_counts.freelance = 0;
      app.notify_counts.projects = 0;
      app.notify_counts.invoices = 0;
      Api.loadNotify(app.notify, function (notifys) {

        var projects_count = 0;
        var freelance_count = 0;
        var invoices_count = 0;
        var comments_count = 0;
        if (notifys.length) {
          notifys.forEach(function callback(currentValue, index, array) {
            if (currentValue.isread == 0 && currentValue.json.type == "projects") {
              projects_count++;
            }
            if (currentValue.isread == 0 && currentValue.json.type == "freelance") {
              freelance_count++;
            }
            if (currentValue.isread == 0 && (currentValue.json.type == "comments" || currentValue.json.type == "blogpost_new_comment")) {
              comments_count++;
            }
            if (currentValue.isread == 0 && currentValue.json.type == "invoices") {
              invoices_count++;
            }
          })
          app.notify_counts.comments = comments_count;
          app.notify_counts.freelance = freelance_count;
          app.notify_counts.projects = projects_count;
          app.notify_counts.invoices = invoices_count;
        }


        app.notifys = notifys;
        app.is_notify_load = true;

      });
    },
    markerAllNotifyRead() {
      var app = this;
      Api.setReadAllNotify(function () {
        app.notify_count = 0;

        app.notifys = [];
        app.is_notify_load = false;
        app.notify_counts.comments = 0;
        app.notify_counts.freelance = 0;
        app.notify_counts.projects = 0;
        app.notify_counts.invoices = 0;
        app.loadNotify();
      });
    },
    invokeSave() {
      var app = this;
      if (app.modal_params.type && app.modal_params.type == "post_new") {
        {
          this.$refs.editor._data.state.editor.save()
              .then((data) => {
                // Do what you want with the data here

                var app = this;
                var newPost = app.form;
                newPost.json = data;
                Api.createPost(newPost, function (result) {
                  if (result.iserror == false) {
                    app.iserror = false;
                    app.modals.add_project = false;
                    app.form = {};
                    app.$refs.editor._data.state.editor.clear();
                    document.location.hash = "#/post/"+result.alias+"/" + result.post_id+"/";
                  } else {
                    app.iserror = true;
                    app.error_message = result.error_message;
                  }
                });


                console.log(data)
              })
              .catch(err => {
                console.log(err)
              })
        }
      }else if(app.modal_params.type=="editlead"){

        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              // Do what you want with the data here

              var app = this;
              var newPost = {}
              newPost.json = data;
              var lead_id=app.modal_params.lead_id;
              Api.updateLead(newPost,lead_id, function (data) {
                app.iserror=false;
                app.modals.add_project = false;
                app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});

              },function(error){
                app.iserror = true;
                app.error_message = error;
              });



            })
            .catch(err => {
              console.log(err)
            })
      } else if(app.modal_params.type=="addlead"){
        var custom_fields=app.modal_params.fields_value;
        var funnel_id=app.modal_params.funnel_id;
        var category_id=app.form.category;
        var json_request={
          "category":category_id,
          "funnel_id":funnel_id,
          "lead_data":custom_fields,
          "json":{
            "blocks":[
              {
                "type": "header",
                "data": {
                  "text": "Безымянный проект",
                  "level": 2
                }
              },
              {
                "type" : "paragraph",
                "data" : {
                  "text" : "Без какого либо описания",
                }
              }
            ]
          }
        };
        Api.addLead(json_request,function(data){


          app.iserror = false;
          app.modals.add_project = false;
          app.$router.push({name: 'lead', params: {id: data.lead_id, "rand": Math.random()}});

        },function(error){
          app.iserror = true;
          app.error_message = result.error_message;
        });

      }else if (app.modal_params.type && app.modal_params.type == "post_edit") {
        {
          this.$refs.editor._data.state.editor.save()
              .then((data) => {
                // Do what you want with the data here

                var app = this;
                var newPost = app.form;
                newPost.json = data;
                newPost.last_id = app.modal_params.post_id;
                Api.createPost(newPost, function (result) {
                  if (result.iserror == false) {
                    app.iserror = false;
                    app.modals.add_project = false;
                    app.form = {};
                    app.$refs.editor._data.state.editor.clear();
                    //  app.is_load_projects = false;
                    document.location.hash = "#/post/" + result.post_id;

                    app.$router.push({name: 'post', params: {id: result.post_id, "rand": Math.random()}});
                  } else {
                    app.iserror = true;
                    app.error_message = result.error_message;
                  }
                });


                console.log(data)
              })
              .catch(err => {
                console.log(err)
              })
        }
      } else if (app.modal_params.type && app.modal_params.type == "edit") {


        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var custom_fields={};
              if(app.form.fields){
                //custom_fields=app.form.fields;

                //custom_fields=app.form.fields;


                console.log('start custom fields');

                Object.keys(app.form.fields).forEach(key => {
                  const element = app.form.fields[key];

                  custom_fields[key]=element;
                  // ...
                })


              }

              // Do what you want with the data here

              var edit_project = {'fields':custom_fields,"last_id": app.modal_params.project_id, "json": data};
              Api.editProject(edit_project, function () {
                app.iserror = false;
                app.modals.add_project = false;
                eventBus.$emit("update_project_info", {json: edit_project.json})
                {


                }

                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            })
            .catch(err => {
              console.log(err)
            })
      } else if (app.modal_params.type && (app.modal_params.type == "addwork" || app.modal_params.type == "editwork")) {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var newWork = app.modal_params.newWork;
              newWork.json = data;
              Api.addWork(newWork, function () {
                app.iserror = false;
                app.data = [];
                Api.loadUserPortfolio();
                app.config.blocks = null;
                app.modals.add_project = false;
                app.$refs.editor._data.state.editor.clear();
              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })

            })
            .catch(err => {
              console.log(err)
            })
      } else if (app.modal_params.type && app.modal_params.type == "addtask") {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              var edit_project = {"last_id": app.modal_params.project_id, "json": data};
              edit_project.developer = app.new_task_developer;
              Api.addTask(edit_project, function (tasks) {
                app.iserror = false;
                app.modals.add_project = false;
                app.is_add_task = false;
                eventBus.$emit("update_project_tasks", {tasks: tasks})
                {


                }


                app.$refs.editor._data.state.editor.clear();

              }, function (message) {
                app.iserror = true;
                app.error_message = message;
              })
            })
            .catch(err => {
              console.log(err)
            })


      } else {
        this.$refs.editor._data.state.editor.save()
            .then((data) => {
              // Do what you want with the data here

              var app = this;
              var newTask = app.form;
              newTask.json = data;
              Api.createProject(newTask, function (result) {
                if (result.iserror == false) {
                  app.iserror = false;
                  app.modals.add_project = false;
                  app.form = {};
                  app.$refs.editor._data.state.editor.clear();
                  app.is_load_projects = false;
                  document.location.hash = "#/project/" + result.project_id;
                  app.$router.push({name: 'project', params: {id: result.project_id, "rand": Math.random()}});
                } else {
                  app.iserror = true;
                  app.error_message = result.error_message;
                }
              });


              console.log(data)
            })
            .catch(err => {
              console.log(err)
            })
      }


    },
    clickNotify(button, notify, notify_index) {
      console.log('click notify btn');
      console.log(button);
      console.log(notify);
      var app = this;
      Api.setReadNotify(notify.last_id, function () {

        if (app.notify.show_only_unread == true) {
          app.loadNotify();
        }
        if (button.type == "load_invoice") {
          app.$router.push({"name": "invoice", "params": {"id": button.params.invoice_id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();
        }
        if (button.type == "load_project") {
          app.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // this.$router.push({"name": "project", "params": {"id": button.params.id, "rand": Math.random()}});
          // vm.$forceUpdate();

        }
        if(button.type=="load_post"){
          app.$router.push({"name": "post", "params": {"id": button.params.id, 'alias':button.params.alias,"rand": Math.random()}});
        }
        if (button.type == "remove_notify") {
          Api.setRemoveNotify(notify.last_id, function () {
            app.loadNotify();
          });
        }
      });

    },
    telegramLoginCallback(user) {

      // gets user as an input
      // id, first_name, last_name, username,
      // photo_url, auth_date and hash
      console.log(user);
      var app = this;
      app.modals.add_project = false;

      axios.post(Vue.config.API_URL + `login`, user)
          .then(response => {

            if (response.data.type == "success") {
              localStorage.setItem('api_token', response.data.user.api_token);
              app.$store.commit('SET_TOKEN', response.data.user.api_token);

              eventBus.$emit('reload', response.data.user);
              this.modal_add_title = "Размещение проекта";
              if (app.show_modal_after_login == true) {
                app.modals.add_project = true;
              } else {
                app.modals.add_project = false;
              }
            } else {
              alert(response.data.message);
            }
          })
          .catch(e => {
            console.log(e);
          })
    }
  }
};
</script>
<style>
</style>
